// 基础响应数据
const requestBaseData = {
  code: 0,
  reasonCode: 0,
  requestId: '1234567890',
  msg: 'success',
  time: new Date().getTime(),
  requiredVersion: {
    merchantWeb: '1.0.0',
    clientWeb: '1.0.0'
  },
};

// FAQ模块mock响应
const faqMockResponses = {
  '/api/brand/v1/faq/getCategories': {
    ...requestBaseData,
    data: {
      categories: [
        { id: '1', name: '产品功能' },
        { id: '2', name: '账户管理' },
        { id: '3', name: '支付问题' }
      ]
    }
  },
  '/api/brand/v1/faq/getQuestions': {
    ...requestBaseData,
    data: {
      questions: [
        { 
          id: '101', 
          categoryId: '1', 
          question: '如何创建新项目？',
          answer: '点击右上角"新建项目"按钮，填写项目信息即可创建新项目。'
        },
        { 
          id: '102', 
          categoryId: '2', 
          question: '如何修改密码？',
          answer: '在"个人设置"页面，点击"安全设置"，然后选择"修改密码"。'
        }
      ]
    }
  }
};

export default faqMockResponses;
